/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import Vue from 'vue/dist/vue.esm';

import FileUpload from '@websanova/vue-upload';
import VueI18n from 'vue-i18n';
import VueResource from 'vue-resource';
import VeeValidate from 'vee-validate';
import VueLazyload from 'vue-lazyload';
import VueNumeric from 'vue-numeric'
import VCalendar from 'v-calendar';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faGift } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import Locales from '../src/locales/locales';

import store from '../src/store';
import MapApp from '../src/components/map-app/map-app';
import CollapsibleItem from '../src/components/list/collapsible-item.vue';
import CollapsibleList from '../src/components/list/collapsible-list.vue';
import ProjectPurchaseForm from '../src/components/project-purchase-form/project-purchase-form';
import BrandPurchaseForm from '../src/components/brand-purchase-form/brand-purchase-form';
import FoundationPurchaseForm from '../src/components/foundation-purchase-form/foundation-purchase-form';


document.addEventListener('DOMContentLoaded', () => {
  library.add(faGift);

  Vue.use(VueI18n);
  Vue.use(VueLazyload);
  Vue.use(FileUpload);
  Vue.use(VueNumeric)
  Vue.use(VueResource);
  Vue.use(VeeValidate);
  Vue.use(VCalendar, {
    firstDayOfWeek: 2,
    locale: 'es',
    titlePosition: 'center',
    datePickerShowDayPopover: false,
    themeStyles: {
      wrapper: {
        padding: '10px',
        margin: '30px',
        background: 'white',
        color: '#58585b',
        borderRadius: '6px',
        boxShadow: '0 2px 23px 0 #E4E6E9',
        fontFamily: 'Karla',
      },
      dayCellNotInMonth: {
        opacity: 0,
      },
    },
  });
  Vue.component('font-awesome-icon', FontAwesomeIcon);

  return new Vue({
    el: '#vue',
    i18n: new VueI18n({
      locale: document.documentElement.lang,
      messages: Locales.messages,
    }),
    store,
    components: {
      MapApp,
      CollapsibleItem,
      CollapsibleList,
      BrandPurchaseForm,
      ProjectPurchaseForm,
      FoundationPurchaseForm,
    },
  });
});
